import { Injectable } from '@angular/core';
import { HttpService } from './http.service';
import { map, Observable } from 'rxjs';
import { FontModel } from '../models';
import { CachedHttpService } from './cached-http.service';

@Injectable({
  providedIn: 'root'
})
export class FontsApiService {


  constructor(private cacheHttpService: CachedHttpService) { }

  public getPlatformFonts(): Observable<FontModel[]> {
    return this.cacheHttpService.get<{ items: FontModel[] }>('platform-fonts')
      .pipe(
        map(data => data?.items || [])
      )
  }

}